import clsx from 'clsx';
import { Image } from '../Image/Image';
import { useCreditCard } from './CreditCard';

type CreditCardFlagProps = {
  region: string;
}

export const CreditCardFlag = ( { region }: CreditCardFlagProps ) => {
  const creditCard = useCreditCard();

  return (
    <Image
      src={ `https://cdn.rewarble.com/flags/${ region?.toUpperCase() }.svg` }
      className={ clsx(
        'rounded-sm border border-white/40 object-cover',
        {
          'w-[30px] h-[20px]': creditCard.size === 'default',
          'w-[20px] h-[14px]': creditCard.size === 'sm'
        }
      ) }
      width={ 30 }
      height={ 20 }
      config={ 'format-webp format-png w-[60px] h-[40px] fit-cover' }
    />
  )
}
CreditCardFlag.displayName = 'CreditCardFlag';
